export interface MediaKitAsset {
  id: string;
  label: string;
  filename: string;
  description: string;
  url: string;
}

// Only real assets that actually exist in this repo — logo variants (SVG,
// dark), founder headshots, and product screenshots the ticket also asks
// for don't exist yet (no vector export, no named/photographed founders per
// leadership.ts's own empty state, no product screenshots per ZP-30/31/33's
// precedent) and are honestly omitted rather than faked. Appending a real
// asset here is the only change needed once one exists — useMediaKitDownload.ts
// bundles whatever's listed, nothing is hardcoded per-asset.
export const MEDIA_KIT_ASSETS: MediaKitAsset[] = [
  {
    id: "logo-png",
    label: "ZenFresh Logo (PNG)",
    filename: "zenfresh-logo.png",
    description: "Primary logo mark, light background.",
    url: "/logo.png",
  },
];
